export default class EnergyMeter {
  private bar: Phaser.GameObjects.Graphics;

  private foreground: Phaser.GameObjects.Image;

  private x: number;
  private y: number;
  private value: number;
  private p: number;

  private backgroundColour: number = 0x000624;
  private borderColour: number = 0x30aee4;
  private startColour: number = 0xb4e2f5;
  private endColour: number = 0xb4e2f5;

  private width: number = 340;
  private height: number = 16;

  private border: number = 4;

  constructor(scene: Phaser.Scene, y: number, x?: number) {
    this.bar = new Phaser.GameObjects.Graphics(scene);

    // this.bar.setPipeline("blur");

    this.x = x
      ? x
      : (scene.cameras.main.width - (this.width + this.border * 2)) / 2;
    this.y = y;
    this.value = 100;
    this.p = this.width / 100;

    this.draw();
    scene.add.existing(this.bar);

    this.foreground = scene.add.image(this.x-34,this.y-37,"runner-atlas","energy-bar.png").setOrigin(0);

    // scene.add.existing(this.foreground);
  }

  reset() {
    this.value = 100;
  }

  decrease(amount: number): boolean {
    this.value -= amount;

    if (this.value < 0) {
      this.value = 0;
    }

    this.draw();

    return this.value === 0;
  }

  increase(amount: number) {
    this.value += amount;

    if (this.p * this.value > this.width) {
      this.value = this.width / this.p;
    }

    this.draw();
  }

  draw() {
    this.bar.clear();

    //  BG with boarder
    // this.bar.fillStyle(this.borderColour);
    // this.bar.fillRoundedRect(this.x, this.y, this.width, this.height, 3);

    //  main background
    this.bar.fillStyle(this.backgroundColour);
    this.bar.fillRect(
      this.x + this.border,
      this.y + this.border,
      this.width - this.border * 2,
      this.height - this.border * 2
    );

    if (this.value < 30) {
      this.bar.fillStyle(this.endColour);
    } else {
      this.bar.fillStyle(this.startColour);
    }

    const d = Math.floor(this.p * this.value);

    this.bar.fillRect(
      this.x + this.border,
      this.y + this.border,
      d,
      this.height - this.border * 2
    );
  }
}
